// extracted by mini-css-extract-plugin
export default {"center":"Button_center__+aCUT","button":"Button_button__C57hB","buttonContent":"Button_buttonContent__6gVpY"};